import React from 'react';
export function StickyMobileCTA() {
  return <div className="fixed inset-x-0 bottom-0 z-40 border-t border-gray-200 bg-white p-3 shadow-[0_-4px_12px_rgba(0,0,0,0.08)] sm:hidden" data-id="element-155" data-mp="2286dy2kh2wl4">
      <a href="#comprar" className="flex w-full items-center justify-center rounded-lg bg-coral py-3 text-base font-bold text-white transition-colors duration-150 ease-out hover:bg-coral-dark" data-id="element-156" data-mp="1orq1buawje6g">
        Acceso ahora — 17,99€
      </a>
    </div>;
}